/**
 * Browser storage for Hub auth session tokens.
 */

export const ACCESS_TOKEN_KEY = 'cpa_access_token';
export const REFRESH_TOKEN_KEY = 'cpa_refresh_token';
export const USER_EMAIL_KEY = 'cpa_user_email';

export function getStoredToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getStoredRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getStoredUserEmail(): string | null {
  return localStorage.getItem(USER_EMAIL_KEY);
}

export function setStoredSession(
  accessToken: string,
  refreshToken: string,
  email: string
): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(USER_EMAIL_KEY, email);
}

export function clearStoredToken(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_EMAIL_KEY);
  // Clear legacy Google auth storage if present.
  localStorage.removeItem('auth_user');
}
